namespace $ { $mol_style_attach( "mol/form/demo/demo.view.css",
 "[mol_form_demo] {\n\twidth: 80rem;\n\tflex-direction: column;\n}\n"
) }